import React from 'react';
import { ActionButton } from './ActionButton';
import { MID_GRAY } from '@/styles/tokens';

interface DeviceProviderDrilldownProps {
  onBack: () => void;
  onHomeAssistantBinding?: () => void;
  onDeviceBinding?: () => void;
}

export const DeviceProviderDrilldown: React.FC<DeviceProviderDrilldownProps> = ({
  onBack,
  onHomeAssistantBinding,
  onDeviceBinding,
}) => {
  const selectProvider = (callback: () => void) => {
    onBack();
    callback();
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' }}>
        <ActionButton variant="back" onClick={onBack}>
          ← Back
        </ActionButton>
        <span style={{ fontSize: '12px', color: MID_GRAY.DEFAULT }}>
          Choose device provider
        </span>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {onHomeAssistantBinding && (
          <ActionButton onClick={() => selectProvider(onHomeAssistantBinding)}>
            Home Assistant
          </ActionButton>
        )}
        {onDeviceBinding && (
          <ActionButton onClick={() => selectProvider(onDeviceBinding)}>
            Manual / Generic Device
          </ActionButton>
        )}
      </div>
    </>
  );
};
